import Module from '../../utils/modules/Module';


export default class StoryTellingPage extends Module {
  constructor (options) {
    super(options)

    this.DOMEl = options.element;

    this.stblocks = this.DOMEl.querySelectorAll(".st-module");
    this.scrollTriggersST = [];

    this.floatings = this.DOMEl.querySelectorAll(".floating")
    this.scrollTriggersFloatings = [];

    this.textTowImages = this.DOMEl.querySelectorAll(".tx2img")
    this.scrollTriggerTextTwoImages = [];

    gsap.delayedCall(0.3, this.init.bind(this))

  }

  init() {

    // LINES
    this.scrollTriggersST = Array.from(this.stblocks).map(block => {
      return gsap.fromTo( block.querySelector(".storyline"), { transform: 'scaleY(0)' }, { transform: 'scaleY(1)', scrollTrigger: {
        start: 'top-=120 top+=200',
        markers : false,
        trigger: block,
        scrub: 1
      }})
    })

    // IMAGES PARALLAX
    this.scrollTriggersFloatings = Array.from(this.floatings).map(floating => {
      const imgOneTween = gsap.fromTo(floating.querySelector(".floating-img1"), {yPercent: 30}, {
        yPercent: 0,
        scrollTrigger: {
          start: 'top bottom',
          end: 'bottom center',
          trigger: floating,
          scrub: true
        },
      });

      const imgTwoTween = gsap.fromTo(floating.querySelector(".floating-img2"), {yPercent: -20}, {
        yPercent: 0,
        scrollTrigger: {
          start: 'top bottom',
          end: 'bottom center',
          trigger: floating,
          scrub: true
        },
      });
      return {
        img1: imgOneTween,
        img2: imgTwoTween
      }
    })

    this.scrollTriggerTextTwoImages = Array.from(this.textTowImages).map(block => {
      return gsap.fromTo(block.querySelector(".tx2img-img2"), {yPercent: 30}, {
        yPercent: -5,
        scrollTrigger: {
          start: 'center center',
          end: 'bottom top',
          trigger: block,
          scrub: true
        },
      });
    })
  }
}
